import React, { useState, useEffect, useCallback } from 'react';
import { ExternalLink } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function SponsorBanner({ adFree }) {
  const [sponsors, setSponsors] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  const fetchSponsors = useCallback(async () => {
    try {
      const response = await fetch(`${API_URL}/api/ads/sponsors`);
      if (response.ok) {
        const data = await response.json();
        setSponsors(data);
      }
    } catch (err) {
      console.log('Failed to load sponsors');
    }
  }, []);

  useEffect(() => {
    if (!adFree) {
      fetchSponsors();
    }
  }, [adFree, fetchSponsors]);

  // Rotate sponsors every 15 seconds
  useEffect(() => {
    if (sponsors.length <= 1) return;
    
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % sponsors.length);
        setIsVisible(true);
      }, 300);
    }, 15000);
    
    return () => clearInterval(interval);
  }, [sponsors.length]);

  // Don't show if ad-free or no sponsors
  if (adFree || sponsors.length === 0) {
    return null;
  }

  const sponsor = sponsors[currentIndex];

  return (
    <div 
      className={`transition-opacity duration-300 ${isVisible ? 'opacity-100' : 'opacity-0'}`}
      data-testid="sponsor-banner"
    >
      <a
        href={sponsor.link_url || '#'}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-between p-3 rounded-xl transition-all hover:scale-[1.02]"
        style={{ 
          backgroundColor: 'var(--surface)',
          border: '1px solid var(--surface-highlight)'
        }}
      >
        <div className="flex items-center gap-3">
          {sponsor.image_url && (
            <img 
              src={sponsor.image_url} 
              alt={sponsor.name}
              className="w-10 h-10 rounded-lg object-cover"
            />
          )}
          <div>
            <p className="text-xs font-medium" style={{ color: 'var(--text-main)' }}>
              {sponsor.name}
            </p>
            {sponsor.tagline && (
              <p className="text-xs" style={{ color: 'var(--text-muted)' }}>
                {sponsor.tagline}
              </p>
            )}
          </div>
        </div>
        
        <div className="flex items-center gap-2">
          <span 
            className="text-xs px-2 py-0.5 rounded"
            style={{ backgroundColor: 'var(--surface-highlight)', color: 'var(--text-muted)' }}
          >
            Sponsor
          </span>
          {sponsor.link_url && (
            <ExternalLink className="w-3 h-3" style={{ color: 'var(--text-muted)' }} />
          )}
        </div>
      </a>
    </div>
  );
}
